import { createExperimentHook } from '@prisjakt/ui-experiment';

export const usePrefetchAllLoadOrders = createExperimentHook(
  'prefetch-loadorders',
  false,
  { all: true }
);

export const useShowStoreProductNamesExperiment = createExperimentHook(
  'show-store-product-names',
  { showStoreProductNames: true },
  { hideStoreProductNames: { showStoreProductNames: false } }
);

export const useNonFeaturedStoreLinkExperiment = createExperimentHook(
  'hide-non-featured-store-link',
  { hideNonFeaturedStoreLinks: false },
  { hide: { hideNonFeaturedStoreLinks: true } }
);

export const useSameFontSizeOnMobileExperiment = createExperimentHook(
  'same-font-size-on-mobile',
  { sameFontSizeOnMobile: false },
  { sameFontSizeOnMobile: { sameFontSizeOnMobile: true } }
);
